import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=551ceace&scoped=true"
import script from "./Metadata.vue?vue&type=script&lang=js"
export * from "./Metadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ceace",
  null
  
)

export default component.exports